import React, { useState } from 'react';
import DsModal from '../../common/DsModal';
import { PersonAvatar } from '../../common/avatar/PersonAvatar';
import ArtistCareerTimelineContent, {
  normalizeArtistCareerTimeline,
} from '../../common/profile/ArtistCareerTimelineContent';
import '../../../css/common/chat/MemberListModalCommon.css';

// B: アーティスト一覧（grid/profile/bubble の各表示）の年齢表示の右に置く年表アイコン。
// career_timeline が非空のアーティストだけ表示し、クリックで年表モーダルを開く。
// モーダルの中身は詳細ページと同じ ArtistCareerTimelineContent を再利用する（新規発明しない）。
export default function ArtistCareerTimelineIcon({ artist, className = '' }) {
  const [isOpen, setIsOpen] = useState(false);
  const entries = normalizeArtistCareerTimeline(artist?.career_timeline);

  if (!entries.length) return null;

  const title = `${artist?.name || 'アーティスト'}の年表`;

  // A: モーダル見出しの左にアーティストのアバターを添える。
  // 画像が無ければイニシャル＋性別fallback色（PersonAvatar の共通ルール）で描画する。
  const titleNode = (
    <span className="artist-career-modal__title-lead">
      <PersonAvatar
        type="artist"
        name={artist?.name}
        profilePicture={artist?.profile_picture}
        gender={artist?.gender}
        size={28}
        className="artist-career-modal__title-avatar"
        ariaHidden
      />
      <span className="artist-career-modal__title-text">{title}</span>
    </span>
  );

  // DsModal は body へ portal 描画されるが、React はイベントを DOM 木ではなく React 木で
  // バブルさせるため、モーダル内側のクリック（背面クリックや × など）を止めないと
  // 一覧行の onClick（詳細を開く）まで伝播してしまう。トリガーとモーダルをまとめて
  // 1つの stopPropagation シールドで包む。
  return (
    <span
      className="artist-career-timeline-trigger"
      onClick={(event) => event.stopPropagation()}
    >
      <button
        type="button"
        className={`artist-career-timeline-icon${className ? ` ${className}` : ''}`}
        onClick={() => setIsOpen(true)}
        aria-label={title}
        title={title}
      >
        <i className="fa-solid fa-clock-rotate-left" aria-hidden="true"></i>
      </button>
      {isOpen ? (
        <DsModal
          open
          onClose={() => setIsOpen(false)}
          title={titleNode}
          ariaLabel={title}
          className="artist-career-modal"
          overlayClassName="artist-career-modal__overlay"
          bodyClassName="ds-modal__body--flush"
        >
          <ArtistCareerTimelineContent title={title} entries={entries} showTitle={false} />
        </DsModal>
      ) : null}
    </span>
  );
}
